import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit} from '@angular/core';
import {Event, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router} from '@angular/router';
import {Subscription} from 'rxjs';

const outlets = new Set<RouterLoadingComponent>();

@Component({
    selector: 'router-loading',
    templateUrl: './router-loading.component.html',
    styleUrls: ['./router-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouterLoadingComponent implements OnInit, OnDestroy {
    @Input() matchUrl: string;

    @HostBinding('class.block-loading') private loading = false;

    private sub = Subscription.EMPTY;

    constructor(
        private router: Router,
        private cd: ChangeDetectorRef
    ) {}

    skipLoadingState() {
        this.loading = false;
        this.cd.markForCheck();
    }

    ngOnInit() {
        outlets.add(this);
        this.sub = this.router.events.subscribe((event: Event) => {
            switch (true) {
                case event instanceof NavigationStart: {
                    if (this.matchUrl && (<NavigationStart>event).url.includes(this.matchUrl)) {
                        outlets.forEach(outlet => outlet.skipLoadingState());
                        this.loading = true;
                        this.cd.markForCheck();
                        return;
                    }
                    const outletsStack = [...outlets.values()].reverse();
                    if (outletsStack.some(outlet => outlet.loading)) {
                        return;
                    }
                    outletsStack[0].loading = true;
                    outletsStack[0].cd.markForCheck();
                    return;
                }

                case event instanceof NavigationEnd:
                case event instanceof NavigationCancel:
                case event instanceof NavigationError: {
                    this.skipLoadingState();
                    break;
                }
                default: {
                    break;
                }
            }
        });
    }

    ngOnDestroy() {
        outlets.delete(this);
        this.sub.unsubscribe();
    }
}
